// Autogenerated file
export const countrysEnum = {
    Belarus: "Belarus",
    RussianFederation: "RussianFederation",
    Uzbekistan: "Uzbekistan",
    Kazakhstan: "Kazakhstan",
};
export const countrys = [
    { label: "Беларусь", value: "Belarus", code: "BY", name: "Belarus", phoneCode: "+375", phoneLength: "9,10" },
    { label: "Российская Федерация", value: "RussianFederation", code: "RU", name: "Russian Federation", phoneCode: "+7", phoneLength: "10" },
    { label: "Узбекистан", value: "Uzbekistan", code: "UZ", name: "Uzbekistan", phoneCode: "+998", phoneLength: "9" },
    { label: "Казахстан", value: "Kazakhstan", code: "KZ", name: "Kazakhstan", phoneCode: "+7", phoneLength: "10" },
];
